export default "__VITE_ASSET__DyMSbpaM__"